// TYPES
import { AnyAction,Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { CarObject,Store,Photo } from '../../types';

// ACTION TYPE
import * as types from '../constants';

//Component
import { Toast } from '../../components/Notification'

//HELPER FUNC
import { Queries } from '../../graphql'

//MUTATION
import { FETCH_GLOBAL_SETTING } from '../../graphql/settingsQueries'



// ACTIONS

export function setGlobalSetting( payload: CarObject[] ): AnyAction {
    return {
        type: types.SET_GLOBAL_SETTING,
        payload
    }
}


export function fetchGlobalSetting( ) : ThunkAction<void, Store, any, AnyAction> {
    return (dispatch: Dispatch, getStore ): void=>{        
            
        try {            
            // TODO SET ID TO FETCH CURRENT USER
            Queries(FETCH_GLOBAL_SETTING)
            .then(({data} : any)=>{                               
                dispatch(setGlobalSetting(data.damage_global_setting[0]));                
                
            });                
        }catch(e){
            Toast('error','Something wrong with server... Try again!')
        }        
    }
}

